var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg4 = function Svg4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.703 73h-19.5V58.328H.906V43.047L22.75.625h23.953v42.14h6.188v15.563h-6.188V73Zm-18.61-30.234V29.219c0-.625.032-1.625.095-3 .093-1.375.218-3.14.375-5.297l-2.907 6.187a163.953 163.953 0 0 1-4.312 8.485 111.452 111.452 0 0 1-4.313 7.172h11.063Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#4_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.703 42.766V.625H22.75L.906 43.047v15.281h26.297V73h19.5V58.328h6.188V42.766h-6.188Zm4.188 2h-6.188V2.625H23.97L2.906 43.532v12.796h26.297V71h15.5V56.328h6.188V44.766Zm-20.797 0h-16.77l2.036-3.099a109.411 109.411 0 0 0 4.232-7.038 161.928 161.928 0 0 0 4.256-8.373l.001-.004 2.903-6.18 3.805.994c-.155 2.143-.28 3.899-.373 5.266a72.2 72.2 0 0 0-.09 2.887v15.547Zm-4.438-17.657a163.953 163.953 0 0 1-4.312 8.485 117.8 117.8 0 0 1-3.034 5.172 96.971 96.971 0 0 1-1.279 2h11.063V29.219a69.765 69.765 0 0 1 .093-3c.094-1.375.22-3.14.375-5.297l-2.906 6.187Z",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "4_svg__a",
    x: 0.906,
    y: 0.625,
    width: 65.984,
    height: 81.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "4_svg__b",
    x: 0.906,
    y: 0.625,
    width: 65.984,
    height: 81.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg4;